const factor = 0.621371;
export function convertUnits(to: "km" | "mi" | "miles", value: number): number {
  if (to === "km") {
    return value / factor;
  } else {
    return value * factor;
  }
}
